import { FC } from "react";
import Stack from "@mui/material/Stack";
import { useSchedulePreviewDatesInfoHook } from "../../../utils/hooks/useSchedulePreviewDatesInfo.hook";
import { TooltipText } from "@/components/common/TooltipText";
import { useHover } from "@/utils/hooks/useHover.hook";
import { CopyIconButton } from "@/components/common/CopyIconButton";

interface AutomationsFrequencyCellProps {
  nextRun: string;
  cron: string | null;
  timeZone: string;
  weeklyInterval?: number | null;
}

export const AutomationsFrequencyCell: FC<AutomationsFrequencyCellProps> = ({
  nextRun,
  timeZone,
  cron,
  weeklyInterval,
}) => {
  const { ref, hovered } = useHover();

  const { frequency } = useSchedulePreviewDatesInfoHook({
    nextRun,
    timeZone,
    cron,
    weeklyInterval,
  });

  const firstFrequency = frequency?.at(0);

  if (!firstFrequency) {
    return null;
  }

  return (
    <Stack
      ref={ref}
      spacing={1}
      height="100%"
      direction="row"
      alignItems="center"
      width="fit-content"
      justifyContent="center"
    >
      <TooltipText tooltipTitle={firstFrequency.tooltip}>
        {firstFrequency.label}
      </TooltipText>

      <CopyIconButton visible={hovered} data={firstFrequency.tooltip} />
    </Stack>
  );
};
